// extracted by mini-css-extract-plugin
export default {"ippButtons":"ippButtons__HVhBA","mainForm":"mainForm__c8bHP","loginForm":"loginForm__cLN6Q","ippLarge":"ippLarge__LCTMG","ippWithCaptionWrapper":"ippWithCaptionWrapper__cbtdo","top":"top__tVKLs","bottom":"bottom__zsVT9","captionText":"captionText__QjR3v","noCaption":"noCaption__CphGs","left":"left__C_ISN","mobilecity":"mobilecity__nHB4m","grepo":"grepo__C0rG2","foe":"foe__s4OLa","onyx":"onyx__XASWU","herocity":"herocity__AUuNB","village":"village__OJU1E"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"ippButtons\":\"ippButtons__HVhBA\",\"mainForm\":\"mainForm__c8bHP\",\"loginForm\":\"loginForm__cLN6Q\",\"ippLarge\":\"ippLarge__LCTMG\",\"ippWithCaptionWrapper\":\"ippWithCaptionWrapper__cbtdo\",\"top\":\"top__tVKLs\",\"bottom\":\"bottom__zsVT9\",\"captionText\":\"captionText__QjR3v\",\"noCaption\":\"noCaption__CphGs\",\"left\":\"left__C_ISN\",\"mobilecity\":\"mobilecity__nHB4m\",\"grepo\":\"grepo__C0rG2\",\"foe\":\"foe__s4OLa\",\"onyx\":\"onyx__XASWU\",\"herocity\":\"herocity__AUuNB\",\"village\":\"village__OJU1E\"}";
        // 1787130557202
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  